import styled from "styled-components";

export const AdminEventsModalUser = styled.div`
  margin-bottom: 0.5rem;

  &:last-child {
    margin-bottom: 0;
  }
`;
